<ng-template #loading>
    <app-component-loading></app-component-loading>
</ng-template>

<ng-template #taskOptionsView let-modal>
    <app-button-modal-close *ngIf="!taskOptionsService.boardsForOptions.length"
                            [modal]="modal"></app-button-modal-close>
    <div class="modal-body">
        <div *ngIf="taskOptionsService.isLoadingBoards else loading">
            <ul *ngIf="taskOptionsService.boardsForOptions.length" class="list-group">
                <li (click)="taskOptionsService.onSetBoard(board, true); modal.close()"
                    *ngFor="let board of taskOptionsService.boardsForOptions; let i = index"
                    [attr.data-index]="i"
                    [class.active]="taskOptionsService.selectedBoard && board.alias === taskOptionsService.selectedBoard.alias"
                    class="list-group-item list-group-item-action"
                    data-action='setBoard'>
                    <i [class]="board.icon"></i>
                    <label style="padding-left: 5px">
                        <strong>#{{ board.alias }}</strong> {{ board.name }}
                    </label>
                </li>
            </ul>
            <span *ngIf="!taskOptionsService.boardsForOptions.length"><i>{{ 'EMPTY_LISTS.EMPTY' | translate }}</i></span>
        </div>
    </div>
</ng-template>

<ng-component *ngIf="taskOptionsService.selectedBoard"></ng-component>

<div class="toolbar">
	<div class="toolbar--l1">
		<mat-icon svgIcon="home-4-fill" class="toolbar--l1--menu-home"(click)="navToRoute(['account', 'index'])" > </mat-icon>
		<div class="toolbar--l1--menu-diviver"></div>
		<div class="toolbar--l1--menu-item" (click)="navToRoute(['account', 'tasks','all'])">{{'MAIN_MENU.SUBMENU_ITEMS.BOARDS' | translate}}</div>
		<div class="toolbar--l1--menu-diviver" *ngIf="this.taskOptionsService?.groupSelectedBoard?.title"></div>
		<div class="toolbar--l1--menu-item"
			(click)="navToRoute(['account', 'tasks','all'],true)"
			*ngIf="this.taskOptionsService?.groupSelectedBoard?.title">
				{{this.taskOptionsService?.groupSelectedBoard.title}}
		</div>
	</div>
	<div class="toolbar--l2">
		<button (click)="navBack()"class="button-icon size-xs icononly secondary-button"	>
			<mat-icon svgIcon="arrow-left-line"> </mat-icon>
		</button>
		<div class="toolbar--l2--groupboard_title" *ngIf="taskOptionsService.selectedBoard">
				{{this.taskOptionsService?.selectedBoard?.name}}
		</div>
		<mat-select disableRipple panelClass="nd-select-panel size-l" [value]="this.taskOptionsService?.selectedBoard?.alias"  class="toolbar--l2--boardselect">
			@for (board of  this.taskOptionsService?.boardsForOptions;  track board) {
			<mat-option class="toolbar--l2--boardselect--item" [value]="board.alias" (click)="taskOptionsService.onSetBoard(board, true)" data-action='setBoard' >
				<div class="toolbar--l2--boardselect--item-content">
					<i [class]="board.icon"></i>
					<div>#{{ board.alias }}{{' '}}</div>
					<div>{{ board.name }}</div> 
				</div>
			</mat-option>
			}
		</mat-select>
		<button (click)="onCopyBoardOpen()" *ngIf="taskOptionsService.selectedBoard"
				[disabled]="taskOptionsService.isPermissionsChanged"  class="button-icon size-xs secondary-button"
				data-action='onCopyBoardOpen' type="button">
			<mat-icon svgIcon="file-copy-line"> </mat-icon>
			{{ 'HEADERS.BOARD_SETTINGS.COPY_BOARD_SHORT' | translate }}
		</button>
		<button (click)="deleteBoard()" *ngIf="taskOptionsService.selectedBoard"
				[disabled]="taskOptionsService.isPermissionsChanged" class="button-icon size-xs secondary-button"
				data-action='deleteBoard'
				type="button">
			<mat-icon svgIcon="delete-bin-6-line"> </mat-icon>
			{{ 'MODALS.BUTTONS.DELETE' | translate }}
		</button>

	</div>
	<div class="toolbar--button-group">
		<button (click)="navigateProp('statuses')" class="button-icon size-s" [ngClass]="tab === 'statuses'? 'primary-button' : 'outline-button'" data-action='statuses'>
			{{ 'TASKS.SETTINGS.TABS.STATUS' | translate }}
		</button>
		<button (click)="navigateProp('global')" class="button-icon size-s"	[ngClass]="tab === 'global'? 'primary-button' : 'outline-button'" data-action='global'>
			{{ 'TASKS.SETTINGS.TABS.GLOBAL' | translate }}
		</button>
		<button (click)="navigateProp('types')" class="button-icon size-s" [ngClass]="tab === 'types'? 'primary-button' : 'outline-button'" data-action='types'>
			{{ 'TASKS.SETTINGS.TABS.TASK_TYPES' | translate }}
		</button>
		<button (click)="navigateProp('access')" class="button-icon size-s" [ngClass]="tab === 'access'? 'primary-button' : 'outline-button'" data-action='roles'>
			{{ 'TASKS.SETTINGS.TABS.PERMISSIONS' | translate }}
		</button>
		<button (click)="navigateProp('property')" class="button-icon size-s" [ngClass]="tab === 'property'? 'primary-button' : 'outline-button'" data-action='property'>
			{{ 'TASKS.SETTINGS.TABS.PROPERTIES_2' | translate }}
		</button>
	</div>
</div>
<app-task-statuses *ngIf="tab === 'statuses'"></app-task-statuses>
<app-task-global *ngIf="tab === 'global'"></app-task-global>
<app-task-types *ngIf="tab === 'types'"></app-task-types>
<app-task-access *ngIf="tab === 'access'"></app-task-access>
<app-task-properties *ngIf="tab === 'property'"></app-task-properties>
